import {
  CircularProgress,
  Backdrop,
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Typography,
} from "@mui/material";

import { useEffect, useState } from "react";
import axios from "axios.js";
import AppConfig from "appConfig";
import addNotification from "react-push-notification";
import MDButton from "theme/components/MDButton";

function PushNotificationMgr(payload) {
  // const navigate = useNavigate();
  const { setDisplayState, displayState = false } = payload;
  const [showLoading, setShowLoading] = useState(false);

  function showTestNotification() {
    // const notf = new Notification("Hello There");
    // console.log(notf);
    addNotification({
      title: "Awesome!",
      // subtitle: "Go to go!",
      message: "You will now receive updates instantly from Laddar Africa",
      theme: "darkblue",
      icon: "/logo.png",
      duration: 25000,
      native: true, // when using native, your OS will handle theming.
    });
  }

  async function subscribe(sub) {
    setShowLoading(true);
    setDisplayState(false);

    const json = {
      subscription: sub,
    };

    await axios
      .post("agents/webpush/subscribe.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          showTestNotification();
        } else {
          console.log("Error");
        }
      })
      .catch(() => {
        setShowLoading(false);
      });
  }

  function subscribeToPushManager() {
    navigator.serviceWorker.ready.then((sw) => {
      sw.pushManager
        .subscribe({
          userVisibleOnly: true,
          applicationServerKey: AppConfig.vapid_public_key,
        })
        .then((subscription) => {
          // console.log(subscription.toJSON());
          subscribe(subscription.toJSON());
        });
    });
  }

  async function requestNotificationPermissions() {
    if ("Notification" in window) {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        // Notification("Test Notification");
        subscribeToPushManager();
      } else {
        alert(
          "Notification permission is required. Please reset or unblock your browser permissions and reload this page."
        );
      }
    }
  }

  useEffect(() => {
    if (typeof Notification !== "undefined" && "Notification" in window) {
      if (Notification.permission !== "granted") {
        setDisplayState(true);
      }
    }
  }, []);

  return (
    <Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog open={displayState}>
        <DialogTitle>
          <Box>Stay Informed</Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box>
              <Typography variant="body2" fontWeight="regular">
                Get realtime alerts on new Sales Teams to join, available promotions to earn from
                and instant payment notifications from your customers!
                <br />
                <br />
                Click the Allow button to stay informed.
              </Typography>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setDisplayState(false);
            }}
            color="dark"
            variant="outlined"
          >
            Close
          </MDButton>
          &nbsp;
          <MDButton
            onClick={() => {
              requestNotificationPermissions();
            }}
            color="success"
            variant="outlined"
          >
            Allow
          </MDButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default PushNotificationMgr;
